import { render, staticRenderFns } from "./app-layout-setting.vue?vue&type=template&id=e616fc14&"
import script from "./app-layout-setting.vue?vue&type=script&lang=js&"
export * from "./app-layout-setting.vue?vue&type=script&lang=js&"
import style0 from "./app-layout-setting.vue?vue&type=style&index=0&id=e616fc14&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports